import './NavBar.css';
import NavItems from '../NavItems/NavItems';
import NavHeaders from '../NavHeaders/NavHeaders';


const NavBar = () => {
    return(
        <>
            <NavHeaders/>
            <NavItems/>
        </>
    )
};

export default NavBar;